// extracted by mini-css-extract-plugin
export default {"box":"SaveValueButton_box__2Iwms","btnContainer":"SaveValueButton_btnContainer__v78Gx"};